import { SearchResults } from '@gn-audio/jss-core';

import { ExtendedSearchResults, ExtendedSearchResultsItem } from '../providers';
import { isProductEOL } from './end-of-life-helper';

export const transformSearchResultsWithEOL = (result: SearchResults): ExtendedSearchResults => {
  return {
    ...result,
    items: result.items.map(
      (item): ExtendedSearchResultsItem => ({
        ...item,
        isDiscontinued: isProductEOL({
          itemType: item.itemType,
          groupState: item.groupState,
          familyState: item.familyState,
        }),
      })
    ),
    error: typeof result.error === 'string' ? result.error : undefined,
  };
};
